module.exports = __webpack_public_path__ + "static/media/vsco-icon.34cebfd4.png";